module.exports = __webpack_public_path__ + "img/googleplay.f2caa6f.png";